import { Button, DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLateRouteStatus extends Layout {
    buttonClearColor: Button;
    buttonColorPicker: Button;
    labelPlanningScreenColor: Label;
    panelColorDisplay: Panel;
    panelColorSelector: Panel;
    sourceLateRouteStatus: DataSource;
    switchIsActive: Switch;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
